<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout row wrap justify-end>
      <v-flex xs12 sm12 md3 xl2>
        <SelectCreditors
          :multiple="false"
          :selected="selectedCreditor"
          @selectedCreditors="selectedCreditor = $event"></SelectCreditors>
      </v-flex>
      <v-flex xs12 sm12 md3 xl2>
        <v-select
          v-model="selectedPuplic"
          @change="searchNotifications()"
          success
          clearable
          :items="publicStrategy"
          multiple
          label="Público"
          flat
          box
          class="text-details-none"
          item-text="name"
          item-value="value">
          <template v-slot:selection="{ item, index }">
            <span style="padding-right: 5px" v-if="index === 0">{{ item.name }}</span>
            <span v-if="index === 1" class="grey--text caption"
              >+ ({{
                selectedPuplic.length - 1 + (selectedPuplic.length == 2 ? " outro)" : " outros)")
              }}
            </span>
          </template>
        </v-select>
      </v-flex>
      <v-flex xs12 sm6 md3 xl2>
        <v-select
          v-model="selectedApproachTypes"
          @change="searchNotifications()"
          success
          clearable
          :items="approachesTypes"
          multiple
          flat
          box
          class="text-details-none"
          label="Tipo de abordagem">
          <template v-slot:selection="{ item, index }">
            <span v-if="index == 0">{{ index === 0 ? item : ", " + item }}</span>
            <span v-if="index === 1" style="padding-left: 5px" class="grey--text caption"
              >(+{{
                selectedApproachTypes.length -
                1 +
                (selectedApproachTypes.length == 2 ? " outro)" : " outros)")
              }}</span
            >
          </template>
        </v-select>
      </v-flex>
      <v-flex xs12 sm6 md3 xl2>
        <v-select
          box
          flat
          success
          multiple
          clearable
          hide-details
          label="Gateway"
          item-value="id"
          item-text="name"
          :items="gateways"
          @change="searchNotifications()"
          v-model="selectedGateway">
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0" style="padding-right: 5px">{{
              item.name
            }}</span>
            <span
              v-if="index === 1"
              style="padding-left: 5px"
              class="grey--text caption"
              >(+{{
                selectedGateway.length -
                1 +
                (selectedGateway.length == 2 ? " outro)" : " outros)")
              }}</span
            >
          </template>
        </v-select>
      </v-flex>
      <v-flex xs12 sm6 md3 xl2>
        <v-select
          label="Tipo de disparo"
          v-model="selectedFiringType"
          :items="firingTypes"
          item-text="name"
          item-value="value"
          class="text-details-none"
          success
          clearable
          flat
          box
          @change="searchNotifications()"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm6 md3 xl2>
        <v-md-date-range-picker
          style="margin: 0px !important"
          :opens="'right'"
          @change="handleChange"
          :presets="presets"
          :start-date="this.range.start"
          :end-date="this.range.end"
        ></v-md-date-range-picker>
      </v-flex>
      <v-flex xs12 sm6 md6 xl1>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-switch
                label="Atualizar"
                style="justify-content: flex-end"
                hide-details
                v-model="autoUpdate"
              ></v-switch>
            </span>
          </template>
          <span>Atualizar dados automaticamente</span>
        </v-tooltip>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          locale="pt-br"
          rows-per-page-text="Mostrar"
          no-data-text="Nenhum disparo encontrado"
          style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px"
          :headers="headers"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :items="firings"
          :rows-per-page-items="pagination.rowsPerPageItems">

          <template slot="items" slot-scope="{ item }">
            <tr>
              <td class="grey--text caption">#{{ item.id }}</td>
              <td>{{ item.creditor_name }}</td>
              <td
                :style="
                  item.strategy_public ? `color:${strategyPublic[item.strategy_public].color}` : ''
                ">
                <b>{{
                  item.strategy_public
                    ? strategyPublic[item.strategy_public].name.toUpperCase()
                    : ""
                }}</b>
              </td>
              <td>
                <a @click="goToApproach(item)">
                  <span :class="`tag-approach-type small ${item.approach_type}`">
                    {{ approachTypeName(item).toUpperCase() }}
                  </span>
                </a>
                <a
                  style="display: inline-grid; align-items: center"
                  @click="
                    item.strategy_id
                      ? goToStrategy(item.strategy_snapshot)
                      : goToStimulus(item.creditor_id)
                  ">
                  <span class="ml-1">
                    {{ nameDisp(item) }}
                  </span>
                </a>
              </td>
              <td>{{ item.type | firingType }}</td>
              <td class="text-xs-center">
                <OwnerChip
                  :owner="item.gateway ? item.gateway.code : '--'"
                  :label="item.gateway ? item.gateway.name : '--'"
                  unknown-label="--"
                  disable-tooltip
                ></OwnerChip>
              </td>
              <td>
                <NotificationCell
                  :item="item"
                  :loading="loading || loadingDelivered"
                  :approaches-with-delivery="approachesWithDelivery"
                  @set-firing="setFiring"
                ></NotificationCell>
              </td>
              <td class="text-xs-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" :color="color(item.status)">{{ status(item.status) }}</v-icon>
                  </template>
                  <span>{{ tooltip(item.status) }}</span>
                </v-tooltip>
              </td>
              <td>
                <p style="white-space: nowrap">
                  {{ nameUser(item) }}
                  <v-tooltip top v-if="item.created_at">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item.created_at | formatDateAgo }}</span>
                    </template>
                    <span>Enviado em {{ item.created_at | formatDateTime }}</span>
                  </v-tooltip>
                </p>
              </td>
              <td class="text-xs-center">
                {{ time(item.start_firing, item.end_firing) }}
              </td>
              <td class="text-xs-center">
                <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="cancel(item.id)" :disabled="isDisabled(item.status)">
                      <v-list-tile-title>Cancelar</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile @click="generateReport(item.id)">
                      <v-list-tile-title>Relatório analítico</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile
                      :href="'https://metabase.quiteja.com.br/question/11585?firing_id=' + item.id"
                      target="_blank">
                      <v-list-tile-content>
                        <v-list-tile-title>Webhooks</v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-icon>mdi-open-in-new</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5)">
              <v-layout justify-center align-center>
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="primary"></v-progress-circular>
                <strong v-if="!loading" class="py-2" style="font-size: 14px"
                  >Nenhum disparo encontrado</strong
                >
              </v-layout>
            </v-container>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <NotificationsDialog v-model="dialog" :firing="firing"></NotificationsDialog>
  </v-container>
</template>

<script>
import moment from "moment";
import store from "@/store";
import checkMobile from "@/mixins/checkMobile";
//services
import gatewaysService from "@/services/gateways";
import reportingService from "@/services/reporting/reporting";
import strategyNotificationService from "@/services/notification-history";
//utils
import strategyPublic from "@/utils/strategy-public";
import incentiveApproachUtils from "@/utils/incentive-approach";
//components
import SelectCreditors from "@/components/creditor/SelectCreditors";
import OwnerChip from "@/components/ui/OwnerChip";
import NotificationCell from "./components/NotificationCell.vue";
import NotificationsDialog from "./components/NotificationsDialog.vue";

export default {
  components: {
    SelectCreditors,
    OwnerChip,
    NotificationCell,
    NotificationsDialog,
  },
  data() {
    return {
      incentiveApproachUtils,
      interval: null,
      dialog: false,
      firing: {},
      nameMatch: "",
      space: "_",
      loading: true,
      loadingDelivered: false,
      autoUpdate: true,
      doneFetching: false,
      selectedCreditor: 0,
      selectedFiringType: null,
      gateways: [],
      selectedPuplic: [],
      publicStrategy: [],
      selectedGateway: [],
      selectedApproachTypes: [],
      firingTypes: [
        { name: "Automático", value: "AUTO" },
        { name: "Manual", value: "MANUAL" },
        { name: "Incentivo", value: "INCENTIVE" },
      ],
      approachesTypes: [
        "SMS",
        "PUSH",
        "EMAIL",
        "CALL_CELLPHONE",
        "CALL_PHONE",
        "WHATSAPP",
      ],
      presets: [
        {
          label: "Hoje",
          range: this.getRange(0, 0),
        },
        {
          label: "Ontem",
          range: this.getRange(1, 1),
        },
        {
          label: "Últimos 7 dias",
          range: this.getRange(6, 0),
        },
        {
          label: "Últimos 30 dias",
          range: this.getRange(29, 0),
        },
        {
          label: "Este mês",
          range: this.getRange(0, 0, "month"),
        },
        {
          label: "Mês passado",
          range: this.getRange(1, 1, "month"),
        },
      ],
      headers: [
        {
          text: "ID",
          align: "left",
          value: "id",
          width: "1%",
          sortable: false,
        },
        {
          text: "Credor",
          align: "left",
          value: "creditor_name",
          width: "5%",
          sortable: false,
        },
        {
          text: "Público",
          align: "left",
          value: "strategy_public",
          width: "4%",
          sortable: false,
        },
        {
          text: "Disparo",
          align: "left",
          value: "name",
          sortable: false,
          width: "15%",
        },
        {
          text: "Tipo de Disparo",
          align: "left",
          value: "type",
          width: "4%",
          sortable: false,
        },
        {
          text: "Gateway",
          value: "ggateway",
          align: "center",
          width: "3%",
          sortable: false,
        },
        {
          text: "Notificações",
          value: "notifications",
          width: "9%",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          value: "status",
          width: "1%",
          sortable: false,
        },
        {
          text: "Enviado por",
          align: "left",
          value: "created_at",
          width: "4%",
          sortable: false,
        },
        {
          text: "Duração",
          align: "center",
          value: "localized",
          width: "4%",
          sortable: false,
        },
        {
          text: "Ação",
          align: "center",
          width: "1%",
          sortable: false,
        },
      ],
      query: {},
      creditors: {},
      strategyPublic: {},
      range: {
        start: moment().subtract(0, "day").format("YYYY-MM-DD"),
        end: moment().subtract(0, "day").format("YYYY-MM-DD"),
      },
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "created_at",
        totalItems: 0,
        rowsPerPageItems: [10, 25, 50, 100],
      },
      firings: [],
      approachesWithDelivery: ['SMS', 'WHATSAPP', 'EMAIL']
    };
  },
  mixins: [checkMobile],
  async created() {
    await this.getGateway();

    strategyPublic.strategyPublic.forEach((e, i) => {
      this.strategyPublic[e.value] = strategyPublic.strategyPublic[i];
    });
    this.publicStrategy = strategyPublic.strategyPublic;

    await this.handleQueryParams();

    this.doneFetching = true;
    this.interval = setInterval(async () => {
      if (
        !this.loading &&
        this.pagination.totalItems &&
        this.autoUpdate &&
        this.$route.path == "/notifications"
      ) {
        this.searchNotifications();
      }
    }, 60000);
  },
  watch: {
    pagination: {
      async handler() {
        if (this.doneFetching) {
          await this.searchNotifications();
        }
      },
      deep: true,
    },
    selectedCreditor: {
      async handler() {
        if (this.doneFetching) await this.searchNotifications();
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) this.firing = {};
      },
    },
  },
  methods: {
    async handleQueryParams() {
      this.query = this.$route.query;

      if (this.query && Object.keys(this.query).length == 0) {
        this.query = store.getters.getManualStrategy;
      }
      if (this.query.types) {
        this.query.types.split(",").forEach((id) => {
          this.selectedApproachTypes.push(id);
        });
      }
      if (this.query.creditors) {
        this.query.creditors.split(",").forEach((id) => {
          this.selectedCreditor = parseInt(id);
        });
      }
      if (this.query) {
        if (this.query.start && this.query.end) {
          this.range.start = this.query.start;
          this.range.end = this.query.end;
        }
        if (this.query.sortBy) this.pagination.sortBy = this.query.sortBy;
        if (this.query.descending) this.pagination.descending = this.query.descending;
        if (this.query.rowsPerPage) this.pagination.rowsPerPage = this.query.rowsPerPage;
        if (this.query.page) this.pagination.page = this.query.page;
        if (this.query.descending) {
          if (typeof this.query.descending == "string") {
            this.descending = JSON.parse(this.query.descending.toLowerCase());
          } else {
            this.descending = this.query.descending;
          }
        }
        if (this.query.creditor) {
          this.selectedCreditor = parseInt(this.query.creditor);
          this.query.creditor = this.selectedCreditor;
        }
        if (this.query.public) {
          let _public = this.query.public.split(",");
          _public.forEach((p) => {
            this.publicStrategy.forEach((el) => {
              if (p == el.value) this.selectedPuplic.push(el.value);
            });
          });
        }
        if (this.query.approachTypes) {
          let _types = this.query.approachTypes.split(",");
          this.selectedApproachTypes = [];
          _types.forEach((p) => {
            this.approachesTypes.forEach((el) => {
              if (p == el) this.selectedApproachTypes.push(el);
            });
          });
        }
        if (this.query.gateways) {
          let _gateways = this.query.gateways.split(",");
          this.selectedGateway = [];
          _gateways.forEach((p) => {
            this.gateways.forEach((el) => {
              if (parseInt(p) == el.id) this.selectedGateway.push(el.id);
            });
          });
        }
        await this.searchNotifications();
      } else {
        await this.searchNotifications();
      }
    },

    getRange(startOffset = 0, endOffset = 0, period = "day") {
      return [
        moment().subtract(startOffset, period).startOf(period),
        moment().subtract(endOffset, period).endOf(period),
      ];
    },
    async getGateway() {
      await gatewaysService.gateways().then((resp) => {
        resp.objects.forEach((item) => {
          this.gateways.push({
            id: item.id,
            name: item.name,
          });
        });
      });
    },
    setFiring(notificationFiring) {
      this.firing = Object.assign({}, notificationFiring);
      this.dialog = true;
    },
    updateFiringSkip() {
      for (let i = 0; i < this.firings.length; i++) {
        const el = this.firings[i];
        el.total_skips = 0;
        if (el.firing_skips) {
          el.firing_skips.forEach((s) => {
            el.total_skips += s.skip_count;
          });
        }

        if (el.approach_type && el.approach_type.includes("INCENTIVE")) {
          el.queued = el.notifications + el.total_skips;
        }

        el.not_sent = el.queued ? el.queued - el.notifications : 0;
        el.missing = el.queued - (el.total_skips + el.notifications);

        this.firings[i] = Object.assign(el, {});
      }
    },

    async getDeliveredRates() {
      const firingIds = this.firings
        .filter((f) => f.id && this.approachesWithDelivery.includes(f.approach_type))
        .map((f) => f.id)
        .join(",");

      if (!firingIds) return;

      this.loadingDelivered = true;
      try {
        const deliveredRes =
          await strategyNotificationService.getDeliveredRates(firingIds);

        this.firings = this.firings.map((f) => {
          return {
            ...f,
            ...(deliveredRes[f.id] || {}),
          };
        });
      } catch (error) {
        console.error(error);
        this.$store.commit(
          "showSnackbar",
          "Houve um erro ao buscar as taxas de entrega",
        );
      } finally {
        this.loadingDelivered = false;
      }
    },

    handleChange(values) {
      this.range.start = moment(values[0]._d).format("YYYY-MM-DD");
      this.range.end = moment(values[1]._d).format("YYYY-MM-DD");
      this.searchNotifications();
    },
    async searchNotifications() {
      this.addfilters();
      this.loading = true;
      let params = this.buildParams();
      await strategyNotificationService
        .searchStrategyNotificationHistory(params)
        .then(async (res) => {
          this.firings = res.objects || [];
          this.pagination.totalItems = res.num_results;
          await this.updateFiringSkip();
          await this.getDeliveredRates();
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", "Houve um erro ao buscar os dados");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildParams() {
      let params = {};
      params.page = this.pagination.page;
      params.limit =
        this.pagination.rowsPerPage == -1 ? 9999 : this.pagination.rowsPerPage;

      if (this.nameMatch && this.nameMatch.length)
        params["name_match"] = this.nameMatch;

      if (this.selectedCreditor) params.creditor = this.selectedCreditor;

      if (this.pagination.sortBy)
        params.order =
          (this.pagination.descending ? "-" : "") + this.pagination.sortBy;
      
      if (this.selectedPuplic.length) {
        params["strategy_public"] = this.selectedPuplic
          .map((sp) => sp)
          .join(",");
      }

      if (this.selectedApproachTypes.length) {
        params["approach_types"] = this.selectedApproachTypes
          .map((sp) => sp)
          .join(",");
      } else {
        params["approach_types"] = this.approachesTypes.join(",");
      }

      if (this.selectedGateway.length) {
        params["gateway_ids"] = this.selectedGateway.join(",");
      }

      if (this.range.start && this.range.end) {
        params["start_date"] = this.range.start;
        params["end_date"] = this.range.end;
      }

      if (this.selectedFiringType) {
        params["type"] = this.selectedFiringType;
      }

      return params;
    },

    addfilters() {
      this.query = {};
      if (this.pagination.sortBy) this.query.sortBy = "created_at";
      else this.query.sortBy = 0;
      if (this.pagination.descending) this.query.descending = true;
      if (this.selectedCreditor > 0) this.query.creditor = this.selectedCreditor;
      if (this.range.start && this.range.end) {
        this.query.start = this.range.start;
        this.query.end = this.range.end;
      }
      if (this.selectedPuplic.length) {
        this.query.public = this.selectedPuplic.map((sp) => sp).join(",");
      }
      if (this.selectedApproachTypes.length) {
        this.query.approachTypes = this.selectedApproachTypes.map((sp) => sp).join(",");
      }
      if (this.selectedGateway.length) {
        this.query.gateways = this.selectedGateway.map((id) => id).join(",");
      }
      this.query.rowsPerPage = this.pagination.rowsPerPage;
      this.query.page = this.pagination.page;
      this.$store.commit("setManualStrategy", this.query);
      if (this.$route.path == "/notifications") {
        this.$router.replace({
          name: "Disparos",
          query: this.query,
        });
      }
    },
    time(start, end) {
      if (!start || !end) return "-";
      start = new Date(start);
      end = new Date(end);
      let diff = (end - start) / 1000;
      if (diff <= 60) {
        return diff + "seg";
      }
      let minutes = 0;
      let hours = 0;
      if (diff >= 3600) {
        hours = Math.floor(diff / 3600);
        minutes = Math.floor((diff - hours * 3600) / 60);
      } else {
        minutes = Math.abs(Math.round(diff / 60));
      }

      let text = hours ? hours + "h" : "";
      text += minutes ? (hours ? " e " + minutes + "min" : minutes + "min") : "";
      if (text == "") text = "-";
      return text;
    },

    status(status) {
      switch (status) {
        case "PENDING":
          return "pending";
        case "QUEUED":
          return "next_plan";
        case "ERROR":
          return "error";
        case "CANCELED":
          return "cancel";
        case "SENDING":
          return "outbond";
        case "DONE":
          return "check_circle";
      }
    },

    nameDisp(item) {
      if (item.strategy_id) {
        return item.name;
      } else {
        if (item.type == "INCENTIVE") {
          return item.approach_detail || "";
        } else {
          let name = item.name.split("#");
          return name[1];
        }
      }
    },

    approachTypeName(item) {
      if (item.approach_type.includes("INCENTIVE_")) {
        const step = item.name.split("-")[1];
        const type = incentiveApproachUtils.type[item.approach_type].name;
        return `INCENTIVO ${type} - ${step}`;
      }
      return item.approach_type;
    },

    color(status) {
      switch (status) {
        case "PENDING":
          return "indigo";
        case "QUEUED":
          return "blue";
        case "ERROR":
          return "red";
        case "CANCELED":
          return "orange";
        case "SENDING":
          return "teal";
        case "DONE":
          return "green";
      }
    },

    tooltip(status) {
      switch (status) {
        case "PENDING":
          return "Preparando as mensagens";
        case "QUEUED":
          return "Enviados para a fila de notificação";
        case "ERROR":
          return "Houve um erro no processo de enfileiramento";
        case "CANCELED":
          return "Disparo cancelado";
        case "SENDING":
          return "Enviando mensagens";
        case "DONE":
          return "Mensagens envidadas";
      }
    },

    cancel(id) {
      strategyNotificationService
        .setStatus(id, "CANCELED")
        .then((res) => {
          if (typeof res.status !== "undefined" && res.status == "CANCELED") {
            this.searchNotifications();
            this.$store.commit("showSnackbar", "Cancelado com sucesso!");
          } else {
            console.error(res);
            this.$store.commit("showSnackbar", "Houve um erro ao cancelar");
          }
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", "Houve um erro ao cancelar");
        });
    },

    isDisabled(status) {
      switch (status) {
        case "ERROR":
          return true;
        case "CANCELED":
          return true;
        case "DONE":
          return true;
        default:
          return false;
      }
    },

    generateReport(firingId) {
      if (!firingId) return;

      reportingService
        .generateReport("FIRING", [firingId])
        .then(() => {
          this.$store.commit("showSnackbar", "Relatório enviado para a fila.");
        })
        .catch((err) => {
          console.error(err);
          this.$store.commit("showSnackbar", "Houve um erro ao gerar o relatório.");
        });
    },

    nameUser(item) {
      let strategy_snapshot = {};
      try {
        strategy_snapshot = JSON.parse(item.strategy_snapshot);
      } catch (e) {
        strategy_snapshot = item.strategy_snapshot;
      }
      return (strategy_snapshot && strategy_snapshot.last_notification_user)
        ? strategy_snapshot.last_notification_user.split(" ")[0] + ","
        : "";
    },

    goToStrategy(strategy) {
      let vm = this;
      let name = strategy.active ? "Sob demanda" : "Planejamento";
      this.$router.push({
        name,
        query: {
          strategy_id: strategy.id,
        },
      });
    },

    goToStimulus(creditor_id) {
      this.$router.push({
        name: "Estímulos",
        query: {
          creditor: creditor_id,
        },
      });
    },

    goToApproach(item) {
      if (item.strategy_snapshot) {
        this.$router.push({
          name: "Abordagem",
          params: {
            edit: true,
            approach_id: item.strategy_snapshot.approach_id,
          },
        });
      }
      return;
    },

    goTo() {
      return {
        approach(approach) {
          this.$router.push({
            name: "Abordagem",
            params: {
              edit: true,
              selectedApproach: approach,
              approach_id: approach.id,
            },
          });
        },
      };
    },
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style>
tr {
  cursor: default;
}

.tr-shadow {
  background-color: rgba(0, 0, 0, 0.06);
}

.hot {
  background-color: #f47d76 !important;
  border-color: #f47d76 !important;
}

.received {
  background-color: #d3ffce !important;
  border-color: #d3ffce !important;
}

.span-range {
  display: inline-block;
  width: 45%;
  font-size: small;
}

.good-accurancy {
  font-size: 12px;
  color: #049804;
  font-weight: 400;
}

.v-date-picker-table {
  height: auto !important;
}

.v-date-range .v-menu--inline {
  display: inline;
}

.hot .v-chip__content {
  padding: 4px 5px !important;
  background-color: #f47d76 !important;
  border-color: #f47d76 !important;
}

.received .v-chip__content {
  background-color: #d3ffce !important;
  border-color: #d3ffce !important;
  padding: 0px 9px !important;
}
</style>